import React from 'react';
import { Redirect, Route, Switch } from 'react-router';

import { config } from 'src/config';
import { Layout } from 'src/modules/app/components/Layout';
import { DesignStudio } from 'src/modules/designStudio';
import { Internal } from 'src/modules/internal';
import { Login } from 'src/modules/login';
import { NotFound } from 'src/modules/notFound';
import { SignUp } from 'src/modules/signUp';
import { Mobile } from 'src/modules/signUp/components/Mobile';
import { Provider as ToastProvider } from 'src/shared/providers/Toaster';
import { Route as Routes } from 'src/shared/route';

import { ProjectRoute } from './ProjectRoute';

const Router = () => (
  <Switch>
    {/* Design Studio paths */}
    <ProjectRoute
      dsn={config.SENTRY_DESIGN_STUDIO_DSN}
      layoutWrapper={ToastProvider}
      path={Routes.DESIGN_STUDIO.path}
    >
      <Route path={Routes.DESIGN_STUDIO.path}>
        <DesignStudio />
      </Route>
    </ProjectRoute>
    <ProjectRoute dsn={config.SENTRY_DSN} layoutWrapper={Layout}>
      <Route path={Routes.LOGIN.path}>
        <Login />
      </Route>
      <Route path={Routes.SIGNUP_MOBILE.path}>
        <Mobile />
      </Route>
      <Route path={Routes.SIGN_UP.path}>
        <SignUp />
      </Route>
      <Route path={Routes.INTERNAL.path}>
        <Internal />
      </Route>
      <Route exact path={Routes.ROOT.path}>
        <Redirect to={Routes.LOGIN.path} />
      </Route>
      <Route path="*">
        <NotFound />
      </Route>
    </ProjectRoute>
  </Switch>
);

export { Router };
